import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import IntegrationMarketModal from "../Modal/IntegrationMarketModal";
import Field from "../../../../Pages/Settings/Content/Components/Field";
import Backdrop from "../../../UI/Backdrop/Backdrop";

import {
  RequestSetConfig,
  RequestDeleteConfig,
  RequestUpdateConfig,
} from "../../../../store/actions/integrationsActions";

import "./styles.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const CstrikeSettings = ({ show, setShow, dataTmp = 0, setActiveInt }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [clientid, setClientid] = useState("");
  const [secret, setSecret] = useState("");
  const [confType, setConfType] = useState(false);
  const [hoverBack, setHoverBack] = useState(false);

  const getConfig = useSelector((state) => state.integrations.getConfig);
  const setConfig = useSelector((state) => state.integrations.setConfig);
  const deleteConfig = useSelector((state) => state.integrations.deleteConfig);
  const loadingUpdate = useSelector((state) => state.integrations.loadingUpdate);
  const loading = useSelector((state) => state.integrations.loading);

  let query = useQuery();
  let confTmp = parseInt(dataTmp);

  const closePopupHandler = () => {
    cleanData();
    setShow(false);
    setActiveInt("");
    history.push("/integration-market");
  };

  const cleanData = () => {
    setClientid("");
    setSecret("");
  };

  useEffect(() => {
    if (query.get("t") === "add") {
      setConfType(true);
    } else if (query.get("t") === null) {
      setHoverBack(false);
      cleanData();
    } else {
      setConfType(false);
    }
  }, [query]);

  useEffect(() => {
    if (deleteConfig === "Success" && query.get("conf") === "cstrike" && !loadingUpdate) {
      cleanData();
    }
  }, [deleteConfig]);

  useEffect(() => {
    if (setConfig === "Success" && query.get("conf") === "cstrike" && !loadingUpdate) {
      cleanData();
    }
  }, [setConfig]);

  useEffect(() => {
    if (query.get("conf") === "cstrike") {
      if (getConfig) {
        const configData = getConfig.config[confTmp];
        if (configData) {
          setClientid(configData?.client_id);
          setSecret(configData?.secret);
        }
      }
    }
  }, [getConfig, confTmp]);

  const addConfig = () => {
    if (clientid && secret) {
      const config = {
        client_id: clientid,
        secret: secret,
        bulk: 10,
      };
      const configString = JSON.stringify(config);
      const data = { appname: "cstrike", config: configString };

      dispatch(RequestSetConfig(data));
    } else {
      console.log("error");
    }
  };

  const updateConfigData = () => {
    if (clientid && secret) {
      const config = {
        client_id: clientid,
        secret: secret,
        bulk: 10,
      };
      const configString = JSON.stringify(config);
      const data = {
        appname: "cstrike",
        config: configString,
        mountpoint: getConfig?.config[confTmp]?.client_id,
      };

      dispatch(RequestUpdateConfig(data));
    } else {
      console.log("error");
      // console.log(clientid && secret);
    }
  };

  const delConfig = () => {
    dispatch(
      RequestDeleteConfig({
        inttype: "cstrike",
        mountpoint: getConfig?.config[confTmp]?.client_id,
      }),
    );
  };

  return show ? (
    <IntegrationMarketModal
      title="CS Falcon"
      onBack={() => history.push("/integration-market?bck=" + query.get("conf"))}
      onClose={closePopupHandler}>
      <div className="cstrike-settings">
        <div className="flex flex-align-items-center">
          <div className="flex-column m-r-10">
            <Field
              label="Client Id"
              width="275px"
              value={clientid}
              onChange={(e) => setClientid(e.target.value)}
              placeholder="Enter client id"
            />
          </div>
          <div className="flex-column">
            <Field
              label="Secret"
              width="275px"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              placeholder="Enter secret"
            />
          </div>
        </div>
      </div>

      <div className="integration-market-modal__action">
        {confType ? (
          <button onClick={addConfig} className="primary-button">
            Add Config
          </button>
        ) : (
          <>
            <button onClick={updateConfigData} className="primary-button">
              Update
            </button>
            <button onClick={delConfig} className="danger-button">
              Delete
            </button>
          </>
        )}
      </div>

      {(loading || loadingUpdate) && query.get("conf") === "cstrike" && (
        <Backdrop show={loading || loadingUpdate} message="Please wait..." />
      )}
    </IntegrationMarketModal>
  ) : null;
};

export default CstrikeSettings;
